<div class="row">
	@if (loader0) {
	<div class="col">
		<div class="card pt-2">
			<app-spinner></app-spinner>
		</div>
	</div>
	}@else {
	@for (item of caseCounts; track item.key){
	<a class="col text-center" [routerLink]="['/app/list-appointment']" [queryParams]="item.queryParams">
		<div class="card p-1 data-card" [ngClass]="item.cls">
			<p class="data-card-value fw-bold">
				{{ item.count }}
			</p>
			<p class="data-card-label">
				@if (item.img) {
				<img src="../assets/img/appt-types/{{item.img}}" class="appt-type-img" />
				}
				{{item.label}}
			</p>
		</div>
	</a>
	}
	}
</div>

<div class="row">
	@if (navbar.isViewSaved('Unread_Messages')) {
	<div [ngClass]="getTabColumnClass()">
		<div class="dash-panel overflow-x-hidden card-height-2">
			<div class="dash-panel-header bg-unread">
				<div class="dash-panel-title">
					<span class="dash-panel-icon">
						<fa-icon [icon]="['fas','envelope']"></fa-icon>
					</span>
					<span class="dash-panel-name">{{navbar.isViewSaved('Unread_Messages')?.name}}</span>
					@if(navbar.showInfo){
					<fa-icon class="dash-info-icon" [icon]="['fas','info']"
						[matTooltip]="navbar.isViewSaved('Unread_Messages')?.tooltip || ''">
					</fa-icon>
					}
				</div>
				@if (unreadMessages && unreadMessages.length) {
				<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm me-1" role="button"
					matTooltip="Mark all as read" (click)="markAllAsRead(unreadMessages)">
					<fa-icon [icon]="['fas','check']"></fa-icon>
				</span>
				}
				<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
					{{unreadMessages.length}}
				</span>
			</div>
			<div class="dash-panel-body overflow-y-auto">
				@if (msgLoader) {
				<p class="text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
				@if (unreadMessages.length) {
				<ul class="dash-message-list">
					@for (item of unreadMessages; track $index) {
					<li class="dash-message-item">
						<div class="dash-message-from">
							{{item.f_name}}
							{{item.l_name}}
						</div>
						<div class="dash-message-content">
							@if (item.file_url){
							<div class="icon-container no-delete">
								<file-icon [file]="item.file_url"></file-icon>
							</div>
							}
							<span class="dash-message-text">
								@if(item.validURL){
								<a class="dash-link-text" href="{{item.message}}" target="_blank">{{item.message}}</a>
								}@else{
								{{item.message}}
								}
							</span>
						</div>
						<div class="dash-message-meta">
							<span class="dash-time">
								<fa-icon [icon]="['fas','clock']"></fa-icon>
								{{item.time_string}}
							</span>
							<a class="dash-view-btn" [routerLink]="['/app/appt-details','chat',item.enc_id,'empty']">
								{{item.case_id || 'View'}}
								<fa-icon [icon]="['fas','arrow-right']"></fa-icon>
							</a>
						</div>
					</li>
					}
				</ul>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','inbox']"></fa-icon>
					<p>No unread messages</p>
				</div>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Missed_Calls')) {
	<div [ngClass]="getTabColumnClass()">
		<div class="dash-panel overflow-x-hidden card-height-2 dash-panel--missedcall">
			<div class="dash-panel-header bg-missedcall">
				<div class="dash-panel-title">
					<span class="dash-panel-icon">
						<fa-icon [icon]="['fas','phone']"></fa-icon>
					</span>
					<span class="dash-panel-name">{{navbar.isViewSaved('Missed_Calls')?.name}}</span>
					@if(navbar.showInfo){
					<fa-icon class="dash-info-icon" [icon]="['fas','info']"
						[matTooltip]="navbar.isViewSaved('Missed_Calls')?.tooltip || ''">
					</fa-icon>
					}
				</div>
				@if (unreadCallEntries && unreadCallEntries.length) {
				<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm me-1" role="button"
					matTooltip="Mark all as read" (click)="markAllAsRead(unreadCallEntries)">
					<fa-icon [icon]="['fas','check']"></fa-icon>
				</span>
				}
				<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
					{{unreadCallEntries.length}}
				</span>
			</div>
			<div class="dash-panel-body overflow-y-auto">
				@if (callLoader) {
				<p class="text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
				@if (unreadCallEntries.length) {
				<ul class="dash-message-list">
					@for (item of unreadCallEntries; track $index) {
					<li class="dash-message-item dash-message-item--missedcall">
						<div class="dash-message-from--missedcall">
							{{item.f_name}}
							{{item.l_name}}
						</div>
						<div class="dash-message-content">
							@if (item.file_url){
							<div class="icon-container no-delete">
								<file-icon [file]="item.file_url"></file-icon>
							</div>
							}
							<span class="dash-message-text">
								@if(item.validURL){
								<a class="dash-link-text dash-link-text--missedcall" href="{{item.message}}"
									target="_blank">{{item.message}}</a>
								}@else{
								{{item.message}}
								}
							</span>
						</div>
						<div class="dash-message-meta">
							<span class="dash-time">
								<fa-icon [icon]="['fas','clock']"></fa-icon>
								{{item.time_string}}
							</span>
							<a class="dash-view-btn dash-view-btn--missedcall"
								[routerLink]="['/app/appt-details','chat',item.enc_id,'empty']">
								{{item.case_id || 'View'}}
								<fa-icon [icon]="['fas','arrow-right']"></fa-icon>
							</a>
						</div>
					</li>
					}
				</ul>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','phone-slash']"></fa-icon>
					<p>No missed calls</p>
				</div>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Missed_Appointments')) {
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-missed mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-dark mb-0">
					<div class="dash-panel-title text-dark d-flex align-items-center">
						<span class="dash-panel-icon-dark">
							<fa-icon [icon]="['fas','times-circle']"></fa-icon>
						</span>
						<span class="dash-panel-name text-dark">
							{{navbar.isViewSaved('Missed_Appointments')?.name}}
						</span>
						@if(navbar.showInfo){
						<fa-icon class="ms-2 text-dark" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Missed_Appointments')?.tooltip || ''">
						</fa-icon>
						}
					</div>
					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{missedAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader2) {
				@if (missedAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 40%;">Name</th>
							<th style="width: 30%;">Case Id</th>
							<th style="width: 30%;">
								Date
								<fa-icon [icon]="['fas',getOrderIcon1('follow_up_date_object')]"
									(click)="sortList1('follow_up_date_object')" role="button"
									class="float-end"></fa-icon>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of missedAppts| orderBy:order_by_1+'___'+order_type_1;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td>{{data.follow_up_date}}</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No appointments</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Todays_Appointments')) {
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-appt-today mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">
						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','calendar']"></fa-icon>
						</span>
						<span class="dash-panel-name">
							{{navbar.isViewSaved('Todays_Appointments')?.name}}
						</span>
						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Todays_Appointments')?.tooltip || ''">
						</fa-icon>
						}
					</div>
					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{dateWiseAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader1) {
				@if (dateWiseAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 40%;">Name</th>
							<th style="width: 30%;">Case Id</th>
							<th style="width: 30%;">
								Date
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of dateWiseAppts;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td>{{data.follow_up_date}}</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No todays appointments</p>
				</div>
				}
				}@else{
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Tele_Consult_Appointments')) {
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-teleconsult mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','video']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Tele_Consult_Appointments')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Tele_Consult_Appointments')?.tooltip || ''">
						</fa-icon>
						}
					</div>

					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{teleconsultAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				<div class="row g-1 p-2">
					<div class="col-10 offset-1 d-flex">
						<div class="input-group input-group-sm me-1">
							<span class="input-group-text">Date</span>
							<input class="form-control" [(ngModel)]="filterTeleCon.date"
								(ngModelChange)="getTeleConsultAppointments();" ngbDatepicker
								#filterTeleCon_date="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
							<button class="btn btn-outline-secondary" (click)="filterTeleCon_date.toggle()"
								type="button">
								<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
							</button>
						</div>
					</div>
				</div>
				@if (!loader9) {
				@if (teleconsultAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 70%;">Name</th>
							<th style="width: 30%;">Case Id</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of teleconsultAppts;" [matTooltip]="data.opd_doctor || ''">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No appointments</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Upcoming_Appointments')) {
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-upcoming mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">
						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','calendar-plus']"></fa-icon>
						</span>
						<span class="dash-panel-name">
							{{navbar.isViewSaved('Upcoming_Appointments')?.name}}
						</span>
						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Upcoming_Appointments')?.tooltip || ''">
						</fa-icon>
						}
					</div>
					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{upcomingAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader6) {
				@if (upcomingAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 40%;">Name</th>
							<th style="width: 30%;">Case Id</th>
							<th style="width: 30%;">
								Date
								<fa-icon [icon]="['fas',getOrderIcon3('follow_up_date_object')]"
									(click)="sortList3('follow_up_date_object')" role="button"
									class="float-end"></fa-icon>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of upcomingAppts| orderBy:order_by_3+'___'+order_type_3;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td>{{data.follow_up_date}}</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No appointments</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Illness_Cases_gt_90_Days')) {
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-illness mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','hospital']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Illness_Cases_gt_90_Days')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Illness_Cases_gt_90_Days')?.tooltip || ''">
						</fa-icon>
						}
					</div>

					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{illnessAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader3) {
				@if (illnessAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 50%;">Name</th>
							<th style="width: 25%;">Case Id</th>
							<th style="width: 20%;">Open Days</th>
							<th style="width: 5%;">
								<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of illnessAppts;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td>{{data.date_diff_days}}</td>
							<td>
								<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No appointments</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Injury_Cases_gt_180_Days')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-injury mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','notes-medical']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Injury_Cases_gt_180_Days')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Injury_Cases_gt_180_Days')?.tooltip || ''">
						</fa-icon>
						}
					</div>

					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{injuryAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader10) {
				@if(injuryAppts.length){
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 50%;">Name</th>
							<th style="width: 25%;">Case Id</th>
							<th style="width: 20%;">Open Days</th>
							<th style="width: 5%;">
								<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of injuryAppts;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td>{{data.date_diff_days}}</td>
							<td>
								<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No appointments</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Potential_Disability')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-disability mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','wheelchair']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Potential_Disability')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Potential_Disability')?.tooltip || ''">
						</fa-icon>
						}
					</div>

					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{disabilityAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader5) {
				@if (disabilityAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 55%;">Name</th>
							<th style="width: 20%;">Case Id</th>
							<th style="width: 20%;" class="text-end pe-2">Status</th>
							<th style="width: 5%;">
								<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of disabilityAppts;">
							<td>
								{{data.full_name}}
							</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td class="text-end pe-2">
								@if (data.disability_per!=null && data.disability_per!='') {
								{{data.disability_per}}%
								}@else {
								-
								}
							</td>
							<td>
								<fa-icon [icon]="['fas','info']" matTooltip="{{data.disability_date}}"></fa-icon>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No appointments</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Hospital_Surgery')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-hosp_surg mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','hospital']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Hospital_Surgery')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Hospital_Surgery')?.tooltip || ''">
						</fa-icon>
						}
					</div>

					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{hospSurgAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader4) {
				@if (hospSurgAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 50%;">Name</th>
							<th style="width: 25%;">Case Id</th>
							<th style="width: 20%;">Status</th>
							<th style="width: 5%;">
								<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of hospSurgAppts;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td>{{data.hos_sur}}</td>
							<td>
								<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No appointments</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Star_Cases')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-star mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','star']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Star_Cases')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Star_Cases')?.tooltip || ''">
						</fa-icon>
						}
					</div>

					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{starAppts.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader7) {
				@if (starAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 45%;">Name</th>
							<th style="width: 25%;">Case Id</th>
							<th style="width: 25%;">Status 3</th>
							<th style="width: 5%;">
								<fa-icon [icon]="['fas','info']" matTooltip="Updated at"></fa-icon>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of starAppts;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td>{{data.status3_name}}</td>
							<td>
								<fa-icon [icon]="['fas','info']" matTooltip="{{data.updated}}"></fa-icon>
							</td>
						</tr>
					</tbody>
				</table>
				}@else{
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('partially_billed')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-partially_billed mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','file-invoice']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('partially_billed')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('partially_billed')?.tooltip || ''">
						</fa-icon>
						}
					</div>

				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader18) {
				@if (partiallyBilledData.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 60%;">Name</th>
							<th style="width: 40%;">Case Id</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of partiallyBilledData;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Reimbursement')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-type mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','money-check']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Reimbursement')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Reimbursement')?.tooltip || ''">
						</fa-icon>
						}
					</div>

					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm" matTooltip="Total">
						{{totalReimbursment}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader13) {
				@if (reimbursementAppts.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th>Name</th>
							<th>Case Id</th>
							<th class="text-end">Amount</th>
							<th></th>
							<th>QR</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of reimbursementAppts;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.id,'empty']">
									{{data.case_id}}
								</a>
							</td>
							<td class="text-end">
								{{data.total_amount}}
							</td>
							<td>
								@if(pdfLoader != data.case_id){
								<fa-icon [icon]="['fas', 'cloud-download-alt']" matTooltip="PDF"
									(click)="getReimbursementPdf(data)" role="button"></fa-icon>
								}@else {
								<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								}
							</td>
							<td>
								<div class="row g-0 align-items-center">
									<div class="col">
										<app-file-upload [allowedFiles]="allowedBillQRFiles" [uploadFolder]="'qrcodes'"
											(uploaded)="qrUploaded($event,data.id)" [flag]="true">
										</app-file-upload>
									</div>
									@if(data.qrcode){
									<div class="col">
										<div class="icon-container no-delete mb-0">
											<file-icon [file]="data.qrcode"></file-icon>
										</div>
									</div>
									}
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Incomplete_Receipts')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-incomplete mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','envelope']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Incomplete_Receipts')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Incomplete_Receipts')?.tooltip || ''">
						</fa-icon>
						}
					</div>

					<span class="badge rounded-pill fw-bold bg-light text-dark shadow-sm">
						{{incompleteBilling.length}}
					</span>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader14) {
				@if (incompleteBilling.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 10%;"></th>
							<th style="width: 60%;">Name</th>
							<th style="width: 30%;">Case Id</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of incompleteBilling;">
							<td>
								@if (data.visit_type) {
								<img src="../../assets/img/appt-types/{{appt_type_images[data?.visit_type]}}"
									class="appt-type-img" [matTooltip]="data?.visit_type" />
								}
							</td>
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('Closure_Report_Not_Sent')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-closure_not_sent mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','file']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('Closure_Report_Not_Sent')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('Closure_Report_Not_Sent')?.tooltip || ''">
						</fa-icon>
						}
					</div>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader15) {
				@if (closureReportNotSent.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 60%;">Name</th>
							<th style="width: 40%;">Case Id</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of closureReportNotSent;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('billing_check')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-billing_check mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','money-bill']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('billing_check')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('billing_check')?.tooltip || ''">
						</fa-icon>
						}
					</div>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader16) {
				@if (billingCheckData.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 60%;">Name</th>
							<th style="width: 40%;">Case Id</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of billingCheckData;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('ready_to_bill')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-ready_to_bill mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','money-bill']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('ready_to_bill')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('ready_to_bill')?.tooltip || ''">
						</fa-icon>
						}
					</div>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader17) {
				@if (readyToBillData.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 60%;">Name</th>
							<th style="width: 40%;">Case Id</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of readyToBillData;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,'empty']">
									{{data.case_id}}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('draft_mails')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-draft_mails mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','envelope']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('draft_mails')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('draft_mails')?.tooltip || ''">
						</fa-icon>
						}
					</div>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader19) {
				@if (reportDraftsData.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 60%;">Name</th>
							<th style="width: 40%;">Case Id</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of reportDraftsData;">
							<td>{{data.full_name}}</td>
							<td>
								<a
									[routerLink]="['/app/appt-details','no',data.case_enc_id,'empty','mails',data.mail_id]">
									{{data.case_id}}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
	@if (navbar.isViewSaved('medicine_supply_card')){
	<div [ngClass]="getTabColumnClass()">
		<div class="card overflow-x-hidden card-height-2">
			<div class="card-header bg-medicine_supply_card mb-0">
				<h5 class="card-title d-flex align-items-center justify-content-between text-light mb-0">
					<div class="dash-panel-title d-flex align-items-center">

						<span class="dash-panel-icon">
							<fa-icon [icon]="['fas','capsules']"></fa-icon>
						</span>

						<span class="dash-panel-name">
							{{navbar.isViewSaved('medicine_supply_card')?.name}}
						</span>

						@if(navbar.showInfo){
						<fa-icon class="ms-2" [icon]="['fas','info']"
							[matTooltip]="navbar.isViewSaved('medicine_supply_card')?.tooltip || ''">
						</fa-icon>
						}
					</div>
				</h5>
			</div>
			<div class="card-body p-0 overflow-y-auto">
				@if (!loader20) {
				@if (medicineSupllyData.length) {
				<table class="table table-hover dash-table align-middle">
					<thead>
						<tr>
							<th style="width: 60%;">Name</th>
							<th style="width: 40%;">Case Id</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let data of medicineSupllyData;">
							<td>{{data.full_name}}</td>
							<td>
								<a [routerLink]="['/app/appt-details','no',data.case_enc_id,data.follo_enc_id]">
									{{data.case_id}}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
				}@else {
				<div class="dash-empty-state">
					<fa-icon [icon]="['fas','calendar-times']"></fa-icon>
					<p>No data found</p>
				</div>
				}
				}@else {
				<p class="mb-0 text-center p-3">
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					Loading...
				</p>
				}
			</div>
		</div>
	</div>
	}
</div>